import React from "react"
import { createUseStyles } from "react-jss"

import colors from "../../styles/colors"

const useStyles = createUseStyles({
  inputGroupWrapper: {
    position: "relative",
    "& :hover": {
      cursor: "pointer",
    },
  },
  inputWrapper: {
    position: "relative",
    borderRadius: 4,
    padding: "0 0 0 55px",
    backgroundColor: (props) => props.backgroundColor || "rgb(240, 244, 252)",
    borderBottom: (props) =>
      props.error ? `1px solid ${colors.red1}` : `1px solid transparent`,
  },
  input: {
    display: "block",
    width: "100%",
    padding: "16px 12px 10px 0",
    border: "none",
    backgroundColor: "transparent",
    fontFamily: "var(--font-montserrat), sans-serif",
    position: "relative",
    zIndex: 10,
    "&:focus": {
      outline: "none",
    },
  },
  inputIcon: {
    display: "inline-block",
    position: "absolute",
    left: 18,
    top: "50%",
    width: 22,
    height: "auto",
    transform: "translateY(-50%)",
  },
  inputError: {
    display: "block",
    fontFamily: "var(--font-montserrat), sans-serif",
    marginLeft: 55,
    fontSize: 12,
    color: colors.red1,
    paddingTop: 3,
  },
  label: {
    display: "inline-block",
    color: (props) => (props.error ? colors.red1 : colors.black5),
    position: "absolute",
    left: 55,
    top: 14,
    fontSize: 16,
    lineHeight: 1,
    fontFamily: "var(--font-montserrat), sans-serif",
    transition: "transform 250ms ease, scale 250ms ease",
    transformOrigin: "left top",
    transform: "scale(1) translateY(0)",
  },
  labelShrink: {
    transform: "scale(0.7) translateY(-12px)",
  },
})

const PlaceInput = React.forwardRef(
  (
    {
      name = "",
      label = "",
      placeholder = "",
      backgroundColor = "",
      value,
      error,
      onChange,
      onBlur,
      icon,
    },
    ref,
  ) => {
    const [focused, setFocused] = React.useState(false)
    const [adjustLabelPosition, setAdjustLabelPosition] = React.useState(false)

    React.useEffect(() => {
      if ((focused || value) && !adjustLabelPosition) {
        setAdjustLabelPosition(true)
      } else if (!focused && !value && adjustLabelPosition) {
        setAdjustLabelPosition(false)
      }
    }, [focused, value])

    const classes = useStyles({ adjustLabelPosition, error, backgroundColor })
    return (
      <div className={classes.inputGroupWrapper}>
        <div className={classes.inputWrapper}>
          <img src={icon} alt="icon" className={classes.inputIcon} />
          <label
            className={`text-blue5/60 ${classes.label}${
              adjustLabelPosition ? ` ${classes.labelShrink}` : ""
            }`}
          >
            {label}
          </label>
          <input
            ref={ref}
            autoComplete="off"
            className={classes.input}
            name={name}
            id={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={() => setFocused(true)}
            onBlur={() => {
              setFocused(false)
              onBlur()
            }}
            aria-label={label}
          />
        </div>
        {error && <span className={classes.inputError}>{error}</span>}
      </div>
    )
  },
)
PlaceInput.displayName = "PlaceInput"

export default PlaceInput
